import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { FeatureFlags } from '../../ts/FeatureFlags';
import { IViewInfo } from '../../ts/models/IViewInfo';
import { requestAvailableActionsForEntity } from '../actions/spaces/AvailableActionsForEntityActions';
import { addContentFavorite, removeContentFavorite } from '../actions/spaces/FavoritesActions';
import { setLayoutType } from '../actions/spaces/LayoutTypeAction';
import { selectSearchText } from '../selectors/ContentFilterSelectors';
import { selectAvailableActionsForEntity } from '../selectors/EntityActionsSelectors';
import { selectInlineBannerInfo } from '../selectors/InlineBannerInfoSelector';
import { selectLayoutType } from '../selectors/LayoutTypeSelector';
import { NavLocationSelectors, selectPreviousUrl } from '../selectors/NavigationStateSelectors';
import { SessionSiteSelectors, SessionUserSelectors } from '../selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '../selectors/SiteUrlsSelectors';
import { selectSpaceInfo } from '../selectors/SpaceInfoSelectors';
import { AppState } from '../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../utils/ConnectUtils';
import { displayBreadcrumbsForNavLocation } from './NavLocation';
import { PageHeader, PageHeaderDispatchProps, PageHeaderOwnProps, PageHeaderStateProps } from './PageHeader';

const mapStateToProps: MapStateToProps<PageHeaderStateProps> = (state: AppState): PageHeaderStateProps => {
  const spaceInfo = selectSpaceInfo(state);
  const inlineBannerInfo = selectInlineBannerInfo(state);
  const item = spaceInfo && spaceInfo.item as IViewInfo;
  const workbookId = item && item.workbook && item.workbook.id;

  return {
    isInVizViewerArea: NavLocationSelectors.inVizViewerArea(state),
    isOnSiteStatusViz: NavLocationSelectors.inSiteStatusViz(state),
    isOnServerStatusViz: NavLocationSelectors.inServerStatusViz(state),
    isInServerArea: NavLocationSelectors.inServerArea(state),
    // TFSID 912777: we need to always know the page we are on in order to choose the page header
    // we can't use spaceInfo selectors because the spaceInfo is not always up to date, because some pages
    // do not update the SpaceInfo
    inSearchNavLocation: NavLocationSelectors.inSearchNavLocation(state),

    spaceInfo: spaceInfo,
    inlineBannerInfo: inlineBannerInfo,
    siteUrls: siteUrlsSelector(state),
    previousUrl: selectPreviousUrl(state),
    workbookActions: selectAvailableActionsForEntity(state, { id: workbookId, contentType: 'workbook' }),
    displayBreadCrumbs: displayBreadcrumbsForNavLocation(NavLocationSelectors.selectNavLocation(state)),
    layoutType: selectLayoutType(state),
    searchTerm: selectSearchText(state),
    isMetricDetail: NavLocationSelectors.isMetricDetail(state),
    isInlineBanner: SessionSiteSelectors.siteTypeName(state) === 'Trial' &&
                    SessionSiteSelectors.subscribeNowEnabled(state) &&
                    (SessionUserSelectors.siteRoleId(state) === 11 || SessionUserSelectors.siteRoleId(state) === 0) &&
                    (FeatureFlags.trialBannerDesignEnabled || SessionSiteSelectors.isInlineBannerEnabled(state))
  };
};

const mapDispatchToProps: MapDispatchToProps<PageHeaderDispatchProps> = (dispatch) => bindActionCreators({
  addContentFavorite: addContentFavorite,
  removeContentFavorite: removeContentFavorite,
  getWorkbookActions: requestAvailableActionsForEntity,
  setLayoutType: setLayoutType
}, dispatch);


export const ConnectedPageHeader: React.ComponentClass<PageHeaderOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(PageHeader);
